import { ReviewUserType } from '../domain/types';

export const reviewUserTypeLabels: Record<ReviewUserType, string> = {
  SELLER: 'Venditore',
  BUYER: 'Compratore',
};
